import { useEffect, useState } from 'react';
import React from 'react'
import { ITopTen } from '../../../types';
import { getOverAllDistrictAndBlockTopTotalUsagesStudent, getOverAllDistrictTopTotalUsagesStudent, getOverAllTopTotalUsagesStudent } from '../../../Services/NewStats/StateOverViewAPIs';
import { useSelector } from 'react-redux';
import { State } from '../../../Reducers/types';

export function useTopStudent() {

  const { filter } = useSelector((state: State) => state);

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [data, setData] = useState<ITopTen>();
  const [isFirst, setIsFirst] = useState<boolean>(true);
  const [paramsValue, setParamsValue] = useState();


  const getTopTenData = async (param) => {
    setIsLoading(true);
    if (param?.district === "all") {
      const res = await getOverAllTopTotalUsagesStudent(param?.type, param?.week_no, filter.year);
      if (res?.data?.Is_Success) {
        setData(res?.data?.response);
      }

      setIsLoading(false)
    }

    if (param?.district !== "all" && param?.block === "all") {
      const res = await getOverAllDistrictTopTotalUsagesStudent(
        param?.type,
        param?.district,
        param?.week_no,
        filter.year
      );
      if (res?.data?.Is_Success) {
        setData(res?.data?.response);
      }
      setIsLoading(false);
    }

    if (param?.district !== "all" && param?.block !== "all") {
      const res = await getOverAllDistrictAndBlockTopTotalUsagesStudent(
        param?.type,
        param?.district,
        param?.block,
        param?.week_no,
        filter.year
      );
      if (res?.data?.Is_Success) {
        setData(res?.data?.response);
      }
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  // const setDataOnParams = () => {
  //   path?.name == "overall";
  //   ? setData(weeklyAvgStudentUsage)
  //   : path?.name == "lt1hrs"
  //   ? setData(weeklyAvgStudentUsagelt1hrs)
  //   : path?.name == "lt2hrs"
  //   ? setData(weeklyAvgStudentUsagelt2hrs)
  //   : console.log("");
  // };
  // const headers = [
  //   { label: "Employ Id", key: "employId" },
  //   { label: "Name", key: "name" },
  //   { label: "School Name", key: "schoolName" },
  //   { label: "School Code", key: "schoolCode" },
  //   { label: "District", key: "district" },
  // ];
  return (
    {
      isLoading,
      setIsLoading,
      isFirst,
      setIsFirst,
      setParamsValue,
      getTopTenData,
      data,
    }
  )
}
